import React, { Fragment } from "react";
import { Query } from "@apollo/client/react/components";

import NotificationNav from "../../components/Notification/NotificationNav/NotificationSubNav";
import { NotificationProvider } from "../../components/Notification/NotificationContext";
import NotificationTable from "../../components/Notification/NotificationTable";

import FullScreenSpinner from "../../global/components/FullScreenSpinner";
import { GET_PAGINATED_NOTIFICATIONS_COUNT } from "./queries";

const renderTable = (navCounts, refetch) => {
  return (
    <NotificationTable
      navCounts={navCounts}
      manualPagination={true}
      refetch={refetch}
    />
  );
};

const NotificationPage = () => {
  return (
    <Query query={GET_PAGINATED_NOTIFICATIONS_COUNT}>
      {({ loading, error, data, refetch }) => {
        if (loading) return <FullScreenSpinner />;
        if (error) return `Error! ${error.message}`;

        if (data && data.getNotificationsCount) {
          const navCounts = data.getNotificationsCount;

          return (
            <Fragment>
              <NotificationProvider>
                <NotificationNav navCounts={navCounts} />
                <div className="content-container">
                  {renderTable(navCounts, refetch)}
                </div>
              </NotificationProvider>
            </Fragment>
          );
        } else {
          return <>Something went terribly wrong!</>;
        }
      }}
    </Query>
  );
};

export default NotificationPage;
